import { hasPermission, hasRole } from '@/utils/auth'

/**
 * 权限指令：
 * v-permission="'user:save'"
 * v-permission="['user:save','user:update']"
 * v-role="'TEACHER'"
 */
function check(el, binding, type) {
  const value = binding.value
  const ok = type === 'role' ? hasRole(value) : hasPermission(value)
  if (!ok && el && el.parentNode) {
    el.parentNode.removeChild(el)
  } else if (!ok && el) {
    el.style.display = 'none'
  }
}

export const permission = {
  inserted(el, binding) {
    check(el, binding, 'permission')
  },
  update(el, binding) {
    // 权限一般登录后固定，update 时再校验一次
    if (binding.value !== binding.oldValue) {
      check(el, binding, 'permission')
    }
  }
}

export const role = {
  inserted(el, binding) {
    check(el, binding, 'role')
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      check(el, binding, 'role')
    }
  }
}

export default permission
